import * as React from "react";
const SvgAddPlus = (props) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M12 4v16M4 12h16", strokeWidth: 2, strokeLinecap: "round" }));
export { SvgAddPlus as ReactComponent };
